
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import RadioOption from "@/entities/RadioOption";

  @Component
  export default class CheckboxButtonGroup extends Vue {
    @Prop({ default: "all", type: String }) value!: string;
    @Prop({ required: true, type: Array }) options!: RadioOption[];
    @Prop({ default: "radioChoice", type: String }) name!: string;

    @Prop({ type: String, default: '' }) readonly parentClass!: string;
    @Prop({ type: String, default: '' }) readonly labelClasses!: string;
    @Prop({ type: String, default: 'checkbox' }) readonly type!: string;
    @Prop({ type: String, default: '#07f' }) readonly color!: string;

get isCheckBox(){
return this.type === 'checkbox'
}


    getreference(index, isId = false){
      return `${isId ? '#': ''}symbol_${index}`
    }
    get getLabelClasses () {
      return {
        'cbx pl-0': true,
        [this.labelClasses]: true,
        'radio_buttons': this.type === 'radio'
      }
    }
    get getSpanClasses () {
      return {
        'radio_button': this.type === 'radio'
      }
    }
    handleChange(event: any) {
      this.$emit("input", event.target.value);
    }
  }
